const changeAddressInfo = (key, value) => {
  return {
    type: 'CHANGE_ADDRESS_INFO',
    key,
    value
  }
}

export default changeAddressInfo;